import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ParameterByDomainService } from '@app/@core/services';
import { GoogleAnaliticsService } from '@app/@core/services/analytics/google-analitics.service';
import { StorageService } from '@app/@core/services/storage/storage.service';
import { DialogQuoteComponent } from '@app/pages/plans/dialog-quote/dialog-quote.component';
import { environment } from '@env/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-navbar-menu',
  templateUrl: './navbar-menu.component.html',
  styleUrls: ['./navbar-menu.component.scss'],
})
export class NavbarMenuComponent implements OnInit {
  public isCollapsed: boolean = true;
  public currentRoute: string = '';
  public linkFenix: string;
  public topLevelDomainPage: string = this._storage.getTopLevelDomain();

  urlBlog: string;
  linkWhats: string | undefined;
  linkEmergency: string | undefined;
  showHeader: boolean = true;
  linkWhatsAppB2B: string | undefined;
  isB2BRoute: boolean = false;
  isTestDomain: boolean = false;

  constructor(
    private _storage: StorageService,
    private _analytics: GoogleAnaliticsService,
    private router: Router,
    private _parameterDomain: ParameterByDomainService,
    private viewportScroller: ViewportScroller,
    private dialog: NgbModal
  ) {
    const topLevelDomain = this._storage.getItem('topLevelDomain');
    const validBlog: string[] = ['co', 'cl', 'pe', 've', 'cr', 'ec', 'mx', 'om'];
    this.urlBlog = validBlog.includes(topLevelDomain!)
      ? 'https://' + window.location.host + '/blog'
      : 'https://traveler-assistance.com/blog';
    this.validateUrlstartsWith();
    this.linkFenix = environment.fenixurl;
    this.currentRoute = this.router.url;
    this.checkB2BRoute();
    this.checkTestDomain();
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
      this.checkB2BRoute();
    });
  }

  ngOnInit(): void {
    window.addEventListener('scroll', this.scrollEvent, true);
    window.addEventListener('resize', this.scrollEvent, true);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.validateUrlstartsWith();
      }
    });
  }

  validateUrlstartsWith() {
    var slug = false;
    const notAllowed = ['/cotizar'];
    for (const item of notAllowed) {
      slug = this.router.url.startsWith(item);
      if (slug) {
        if (item == '/cotizar' && this.router.url.endsWith('/pago-rechazado')) {
          slug = !slug;
        }
        break;
      }
    }
    this.showHeader = !slug;
  }

  checkB2BRoute() {
    const b2bRoutes = ['/cotizador-de-proveedores', '/planes-b2b', '/contacto-b2b', '/preguntas-frecuentes-b2b'];
    this.isB2BRoute = b2bRoutes.some(route => this.currentRoute.startsWith(route));
  }

  checkTestDomain() {
    const currentDomain = window.location.hostname;
    this.isTestDomain = currentDomain.endsWith('localhost') ||
                        currentDomain.endsWith('new.traveler-assistance.com') ||
                        currentDomain.endsWith('staging.traveler-assistance.com');
  }

  scrollEvent = (event: any): void => {
    if (this.showHeader && !this.isB2BRoute && (this._storage.getTopLevelDomain() == 'ec' || this.isTestDomain)) {
      const navbar = document.querySelector('.menu-header') as HTMLElement;
      const navbarElement = document.querySelector('.navbar-nav') as HTMLElement;
      const brandImage = document.querySelector('#brand') as HTMLImageElement;
      const elementoDeReferencia = document.getElementById('ref') as HTMLElement;
      const buttonEmp = document.querySelector('.button-emp') as HTMLElement;
      const referenciaTop = elementoDeReferencia.getBoundingClientRect().top;

      const scrollPosition = window.scrollY;
      // Verifica si la posición de desplazamiento es mayor o igual a 100 píxeles
      if (referenciaTop <= -100) {
        // Agrega la clase al elemento
        navbar.classList.add('init');
        navbarElement.classList.add('init');
        brandImage.src =
          'https://res.cloudinary.com/pervolare-org/image/upload/v1698435900/TAS/home/logo-tas-white_et6rf0.svg';
        buttonEmp.classList.add('init');
      } else {
        // Quita la clase del elemento
        navbar.classList.remove('init');
        navbarElement.classList.remove('init');
        brandImage.src =
          'https://res.cloudinary.com/pervolare-org/image/upload/v1698425615/TAS/home/geop3aigtgwhisftzl7r.svg';
        buttonEmp.classList.remove('init');
      }
    }else{
      const navbar = document.querySelector('.menu-header') as HTMLElement;
      const navbarElement = document.querySelector('.navbar-nav') as HTMLElement;
      navbar.classList.remove('init');
      navbarElement.classList.remove('init');
    }
  };

  ngAfterViewInit() {
    this._parameterDomain.getParameterInfoFooter(this._storage.getTopLevelDomain()).subscribe((info) => {
      this.linkWhats = info[0].BtnWhatsAppSales;
      this.linkEmergency = info[0].BtnEmergency;
    });
    this.linkWhatsAppB2B =
      this._storage.getTopLevelDomain() == 'ec'
        ? 'https://api.whatsapp.com/send?phone=593998337670&text=Hola,%20necesito%20informaci%C3%B3n%20de%20asistencia%20para%20ser%20aliado.'
        : 'https://api.whatsapp.com/send?phone=573214138041&text=Hola,%20necesito%20informaci%C3%B3n%20de%20asistencia%20para%20ser%20aliado.';
  }

  public contactEvent(): void {
    /**Google Analytics Event */
    this._analytics.addEvent('boton_whatsapp');
  }

  scrollToTop() {
    this.viewportScroller.scrollToAnchor('addSupplier');
  }

  scrollToSection(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'})
    }
  }

  goToQuote(): void {
    if (this.currentRoute === '/') {
      this.scrollToSection('quoteApp');
    } else {
      const ref = this.dialog.open(DialogQuoteComponent, {
            centered: true,
            modalDialogClass: 'reQuoteDialog position-relative',
            size: 'xl',
          });
    }
  }
}
